// Official Restore Wellness logo (client-supplied gold artwork).
export default function RestoreMark({ size = 48, tone = "gold", className = "" }) {
  return <img src={`/brand/restore-emblem-${tone}-256.png`} width={size} height={size} alt="Restore Wellness" className={`object-contain ${className}`} />;
}

export function RestoreLogo({ tone = "gold", shimmer = false, className = "", ...rest }) {
  const src = `/brand/restore-logo-${tone}-640.png`;
  const img = <img src={src} alt="Restore Wellness" className={`object-contain ${shimmer ? "h-full w-auto" : className}`} {...(shimmer ? {} : rest)} />;
  if (!shimmer) return img;
  return (
    <span className={`relative inline-block ${className}`} {...rest}>
      {img}
      <span aria-hidden="true" className="logo-shimmer" style={{ WebkitMaskImage: `url(${src})`, maskImage: `url(${src})` }} data-testid="logo-shimmer" />
    </span>
  );
}
